var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpdatedDexterCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 27,
    viewBox: "0 0 19 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 30"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.4657 4.3737C18.114 3.58254 17.5808 2.75412 16.7792 2.00767C14.6105 -0.0155718 12.0056 -0.0106038 11.4725 0.00181629H7.92058L0.430264 7.47376V14.9606C0.427779 17.508 0.426536 20.0541 0.425293 22.6002C0.429021 22.6089 0.43275 22.6176 0.437721 22.6263C0.789432 23.4175 1.32135 24.2459 2.12295 24.9924C4.29287 27.0143 6.89652 27.0106 7.42968 26.9982H10.9828L18.4744 19.5263V12.0394C18.4756 9.49203 18.4781 6.94591 18.4794 4.39978C18.4756 4.39109 18.4719 4.38239 18.4669 4.3737H18.4657ZM14.0438 22.6002H4.85834V4.39978H14.0438V22.6002Z",
    fill: "#013DC4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M18.4792 4.37369V4.39977C18.4755 4.39108 18.4718 4.38238 18.4668 4.37369H18.4792Z",
    fill: "#013DC4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpdatedDexterCall);
export default __webpack_public_path__ + "static/media/UpdatedDexter-call.655f3a6e885e67807cfbb693d5593a9a.svg";
export { ForwardRef as ReactComponent };